import CityPageTemplate from "../city-template/CityPageTemplate";
import { vacavilleConfig } from "./data";

export default function VacavillePage() {
  return <CityPageTemplate config={vacavilleConfig} />;
}